<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          FAQ
          <el-button class="title_btn" @click="addConfirm" type="primary">카테고리 등록</el-button>
        </div>
        <div class="write_tab">
          <div class="write_tab_content" @click="movePage('faq')">
            FAQ목록
          </div>
          <div class="write_tab_content active">
            카테고리 관리
          </div>
        </div>
        <div class="list-content">
          <board-category-component :boardType="'category'"></board-category-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardCategoryComponent from "@/components/board/BoardCategoryComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "FaqCategory",
  mixins: [],
  components: {BoardCategoryComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    movePage(data) {
      this.$router.push(`${data}`);
    },
    addConfirm() {
      EventBus.$emit('addCategory')
    },
  },
  watch: {},
}
</script>

<style lang="scss">
</style>